import styled, {createGlobalStyle, css} from 'styled-components'

export const GlobalStyle = createGlobalStyle`
@keyframes glow {
  0% {
    box-shadow: var(--clr-shadow) 0 0 0;
  }
  100% {
    box-shadow: var(--clr-shadow) 0 1rem 4rem;
  }
}
  :root {
    border: none;
    box-shadow: none;

    --clr-shadow: hsl(355,31%,29%, 0.8);

    --clr-neon: #f25b4f;
    --clr-bright: #3066BE;
    --clr-light: #A4C3B2;
    --clr-medium: #656839;
    --clr-muted: #B79492;

    --clr-text: #fefcfb;
    --clr-text-H: 30;
    --clr-text-S: 50%;
    --clr-text-L: 99%;
}

  @media (max-width: 56rem) {
    body {
      font-size: 13px;
  }}
  @media (max-width: 43rem) {
    body {
      font-size: 10px;
    }
  }

  body {
    color: hsl(var(--clr-text-H), var(--clr-text-S), var(--clr-text-L));
    background: var(--clr-neon);

    font-family: Yaldevi, sans-serif;
    font-weight: 400;

    height: 100vh;
    width: 100vw;

    margin: 0;
    padding: 0;

    overflow: hidden;

    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;

    box-sizing: border-box;

  }
  `

export const Marginals = css`
  position: fixed;
  z-index: 1;
  display: flex;
  /* width: 100vw; */

  pointer-events: none;
`
export const ImgCont = styled.div.attrs(({$isTogether}) => ({
  style: {
    animation: $isTogether ? 'glow 3s infinite alternate' : 'none'
  }
}))`
  position: relative;

  display: flex;
  flex-wrap: wrap;

  height: 100vh;
  width: 75vh;

  transform: translateX(-30vw);
`
export const Wrapper = styled.section.attrs(({$color}) => ({
  style: {
    backgroundColor: $color
  }
}))`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
`
